<div class="container alumni-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-user-graduate"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Alumni Network</h2>
        <p class="page-subtitle">Stay connected with our accomplished graduates</p>
      </div>
    </div>
  </div>

  <!-- Alumni Content Card -->
  <div class="card alumni-card shadow-lg">
    <div class="card-header">
      <h5 class="card-title mb-0">
        <i class="fas fa-graduation-cap me-2"></i>Alumni Resources & Information
      </h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12">
          <!-- Alumni Links -->
          <div class="alumni-links-container">
            <div class="list-group list-group-flush">
              <div class="list-group-item alumni-item" *ngFor="let link of alumniData; let i=index">
                <div class="alumni-item-content">
                  <div class="alumni-icon">
                    <i class="fas fa-file-pdf"></i>
                    <span class="item-number">{{i + 1}}</span>
                  </div>
                  <div class="alumni-details">
                    <a [href]="link.filename" target="_blank" class="alumni-link">
                      {{link.displayText}}
                    </a>
                    <span class="alumni-meta">
                      <i class="fas fa-external-link-alt"></i> View Document
                    </span>
                  </div>
                  <div class="alumni-actions">
                    <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#alumniModal'+i">
                      <i class="fas fa-eye"></i> View
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="!alumniData || alumniData.length === 0" class="empty-state">
            <i class="fas fa-inbox"></i>
            <h4>No Alumni Resources Available</h4>
            <p>Check back later for alumni information and resources.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Section -->
  <div class="row mt-4">
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-primary">
          <i class="fas fa-users"></i>
        </div>
        <h5>Join Alumni Network</h5>
        <p>Connect with fellow alumni and expand your professional network.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-success">
          <i class="fas fa-handshake"></i>
        </div>
        <h5>Mentorship Programs</h5>
        <p>Share your expertise and guide the next generation of pharmacists.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-info">
          <i class="fas fa-calendar-alt"></i>
        </div>
        <h5>Alumni Events</h5>
        <p>Stay updated on reunions, workshops, and networking events.</p>
      </div>
    </div>
  </div>
</div>

<!-- PDF Viewer Modals - Outside container for proper z-index -->
<ng-container *ngFor="let link of alumniData; let i=index">
  <app-pdf-viewer [title]="link.displayText" [url]="link.filename" [id]="'alumniModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>